import React from "react";
import { connect } from 'redux-bundler-react';
import classnames from 'classnames';

class BookmarkListItem extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleClick() {
    const { bookmark, doGoToBookmark } = this.props;
    doGoToBookmark(bookmark);
  }

  handleDelete() {
    const { bookmark, doDeleteBookmark } = this.props;
    doDeleteBookmark(bookmark)
  }

  render() {
    const { theme, bookmark, idx, bookmarkAnimationIdx, bookmarksIsAnimating } = this.props;

    const active = (idx === bookmarkAnimationIdx) && bookmarksIsAnimating;

    const liClass = classnames({
      'list-group-item': true,
      [theme]: active
    })

    const btnClass = classnames({
      'btn': !active,
      'btn-link': !active,
      'btn-xs': !active,
      'overflow-ellipsis': true,
      [theme]: active
    })

    return (
      <li className={ liClass }>
        <div className="row">
          <div className="col-sm-1">
            <i className="mdi mdi-map-marker icon-inline" />
          </div>
          <div className="col-sm-9">
            <span
              onClick={this.handleClick}
              className={ btnClass }
              style={{ maxWidth: "100%" }}
              title={bookmark.name}
            >
              {bookmark.name}
            </span>
          </div>
          <div className="col-sm-1">
            <span onClick={this.handleDelete} className="btn btn-link btn-xs">
              <i className="mdi mdi-delete" />
            </span>
          </div>
        </div>
      </li>
    );
  }
}

export default connect(
  'doGoToBookmark',
  'doDeleteBookmark', 
  'selectTheme',
  'selectBookmarkAnimationIdx',
  'selectBookmarksIsAnimating',
  BookmarkListItem
);
